import React, { FC, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslation } from 'react-i18next';
import ProductPriceHistory from './product-price-history.component';

type PriceHistoryButtonProps = {
    /** The other party: a lab id for a chain user, a chain id for a lab user. */
    counterpartId: string;
    actionId: string;
    actionSetId?: string;
};

/** DD-3697 — a price-list row's "history" entry point; opens the product's timeline. */
const PriceHistoryButton: FC<PriceHistoryButtonProps> = ({
    counterpartId,
    actionId,
    actionSetId,
}: PriceHistoryButtonProps) => {
    const { t: translate } = useTranslation('price-requests');
    const [open, setOpen] = useState(false);
    const label = translate('SHOW_PRICE_HISTORY');

    return (
        <>
            <Tooltip title={label}>
                <IconButton
                    size="small"
                    aria-label={label}
                    onClick={(event) => {
                        // Rows may be clickable; the history must not trigger them.
                        event.stopPropagation();
                        setOpen(true);
                    }}
                >
                    <HistoryIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            {open && (
                <ProductPriceHistory
                    counterpartId={counterpartId}
                    actionId={actionId}
                    actionSetId={actionSetId}
                    open={open}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
};

export default PriceHistoryButton;
